export default {
  type: String,
  default: 'png'
}
